<template>
  <hypto-popup :title="'2 Factor Authentication (User)'" :css="'width-lg'">
    <template v-slot:body>
      <p>Are you sure you want to <b>{{tfaValue === 'Reset' ? 'reset' : tfaValue ? 'enable' : 'disable'}} 2 Factor Authentication</b>{{user.email ? ` for ${user.name || user.email}?` : `?`}}</p>
      <p v-if="tfaValue || tfaValue === 'Reset'">When you click confirm, {{user.email ? user.name || user.email : 'you'}} will be logged out from {{user.email ? 'their' : 'your'}} Hypto account. {{user.email ? 'The user' : 'You'}} will be then asked to link {{user.email ? 'their' : 'your'}} account to the Google authenticator app on {{user.email ? 'their' : 'your'}} mobile device. {{user.email ? 'The user' : 'You'}} will not be able to login without the OTP from Google authenticator app.</p>
    </template>

    <template v-slot:footer>
      <button class="primary-btn" @click="toggle2FA">{{buttonText}}</button>
    </template>
  </hypto-popup>
</template>

<script>
import HyptoPopup from '@/components/global/HyptoPopup'

import ApiServices from '@/services/api/userProfile'
import { mapMutations } from 'vuex'
import UserApis from '@/services/api/users'

export default {
  name: 'User2FA',
  components: { HyptoPopup },
  props: {
    tfaValue: [Boolean, String],
    user: {
      type: Object,
      default: () => {
        return {
          email: null
        }
      }
    }
  },
  computed: {
    buttonText () {
      if (this.tfaValue || this.tfaValue === 'Reset') {
        return this.user.email ? 'Confirm and logout user' : 'Confirm and logout'
      } else {
        return 'Confirm'
      }
    }
  },
  methods: {
    ...mapMutations(['SET_USER_LOGGED_IN']),
    toggle2FA () {
      if (this.user.email) {
        (this.tfaValue === 'Reset') ? this.resetUser2FA() : (this.tfaValue) ? this.enableUser2FA() : this.disableUser2FA()
      } else {
        (this.tfaValue === 'Reset') ? this.reset2FA() : (this.tfaValue) ? this.enable2FA() : this.disable2FA()
      }
    },
    enable2FA () {
      ApiServices.enable2FA().then(response => {
        this.handleResponse(response, 'enable', true)
      })
    },
    disable2FA () {
      ApiServices.disable2FA().then(response => {
        this.handleResponse(response, 'disable')
      })
    },
    reset2FA () {
      ApiServices.reset2FA().then(response => {
        this.handleResponse(response, 'reset', true)
      })
    },
    enableUser2FA () {
      UserApis.enable2FA(this.user.id).then(response => {
        this.handleResponse(response, 'enable', response.data.force_logout)
      })
    },
    disableUser2FA () {
      UserApis.disable2FA(this.user.id).then(response => {
        this.handleResponse(response, 'disable')
      })
    },
    resetUser2FA () {
      UserApis.reset2FA(this.user.id).then(response => {
        this.handleResponse(response, 'reset', response.data.force_logout)
      })
    },
    handleResponse (response, type, isPublic) {
      if (response.success) {
        this.successToastMsg(response.message, {isPublic})

        if (type === 'disable') {
          this.$emit('refreshTFA', false)
        } else {
          if (this.user.email && !response.data.force_logout) {
            this.$emit('refreshTFA', true)
          } else {
            this.SET_USER_LOGGED_IN(false)
          }
        }
      } else {
        this.errorToastMsg(response.message)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  p {
    font-size: 15px;
    text-align: center;

    &:nth-child(2) {
      margin-top: 10px;
    }
  }

  .mobile {
    p {
      text-align: left !important;
    }
  }
</style>
